const ChatListSkeleton = ({ count = 8 }) => {
    return (
        <div className="tw-relative tw-h-[calc(100vh-55px)] tw-bg-white tw-border-r tw-border-gray-200 tw-overflow-hidden tw-flex tw-flex-col tw-animate-fade-in">
            {/* Header skeleton */}
            <div className="tw-px-5 tw-py-5 tw-border-b tw-border-gray-200 tw-bg-gray-50 tw-flex tw-items-center tw-justify-between tw-min-h-[55px]">
                <div className="tw-w-30 tw-h-6 tw-bg-gradient-to-r tw-from-gray-200 tw-via-gray-300 tw-to-gray-200 tw-bg-[length:200%_100%] tw-animate-shimmer tw-rounded-lg"></div>
                <div
                    className="tw-w-8 tw-h-4 tw-bg-gradient-to-r tw-from-gray-200 tw-via-gray-300 tw-to-gray-200 tw-bg-[length:200%_100%] tw-animate-shimmer tw-rounded"
                    style={{ animationDelay: "0.1s" }}
                ></div>
            </div>

            {/* Search bar skeleton */}
            <div className="tw-px-3 tw-py-3 tw-bg-white tw-flex tw-items-center tw-gap-3 tw-border-b tw-border-gray-100">
                <div
                    className="tw-w-5 tw-h-5 tw-bg-gradient-to-r tw-from-gray-200 tw-via-gray-300 tw-to-gray-200 tw-bg-[length:200%_100%] tw-animate-shimmer tw-rounded"
                    style={{ animationDelay: "0.2s" }}
                ></div>
                <div
                    className="tw-flex-1 tw-h-9 tw-bg-gradient-to-r tw-from-gray-100 tw-via-gray-200 tw-to-gray-100 tw-bg-[length:200%_100%] tw-animate-shimmer tw-rounded-lg"
                    style={{ animationDelay: "0.3s" }}
                ></div>
            </div>

            {/* Chat list skeleton items */}
            <div className="tw-flex-1 tw-overflow-hidden tw-pt-2">
                {[...Array(count)].map((_, index) => (
                    <div
                        key={index}
                        className="tw-px-3 tw-py-4 tw-border-b tw-border-gray-100 tw-flex tw-items-start tw-gap-3 tw-bg-white"
                        style={{ animationDelay: `${index * 0.1}s` }}
                    >
                        <div className="tw-w-10 tw-h-10 tw-bg-gradient-to-r tw-from-gray-200 tw-via-gray-300 tw-to-gray-200 tw-bg-[length:200%_100%] tw-animate-shimmer tw-rounded-full tw-flex-shrink-0"></div>
                        <div className="tw-flex-1 tw-flex tw-flex-col tw-gap-2 tw-min-w-0">
                            <div
                                className="tw-w-3/4 tw-h-4 tw-bg-gradient-to-r tw-from-gray-200 tw-via-gray-300 tw-to-gray-200 tw-bg-[length:200%_100%] tw-animate-shimmer tw-rounded"
                                style={{ animationDelay: "0.1s" }}
                            ></div>
                            <div
                                className="tw-w-1/2 tw-h-3 tw-bg-gradient-to-r tw-from-gray-100 tw-via-gray-200 tw-to-gray-100 tw-bg-[length:200%_100%] tw-animate-shimmer tw-rounded"
                                style={{ animationDelay: "0.2s" }}
                            ></div>
                            <div
                                className="tw-w-5/6 tw-h-3 tw-bg-gradient-to-r tw-from-gray-100 tw-via-gray-200 tw-to-gray-100 tw-bg-[length:200%_100%] tw-animate-shimmer tw-rounded"
                                style={{ animationDelay: "0.3s" }}
                            ></div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Loading wave overlay */}
            <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-r tw-from-transparent tw-via-white/20 tw-to-transparent tw-animate-loading-wave tw-pointer-events-none tw-z-10"></div>

            {/* Loading indicator */}
            <div className="tw-absolute tw-bottom-5 tw-left-1/2 tw-transform tw--translate-x-1/2 tw-bg-white/95 tw-px-4 tw-py-2 tw-rounded-full tw-shadow-lg tw-flex tw-items-center tw-gap-2 tw-text-xs tw-text-gray-600 tw-font-medium tw-z-20 tw-backdrop-blur-sm">
                <div className="tw-w-3 tw-h-3 tw-border-2 tw-border-gray-300 tw-border-t-blue-500 tw-rounded-full tw-animate-spin"></div>
                Loading conversations...
            </div>
        </div>
    );
};

export default ChatListSkeleton;
